import React, { useContext } from "react";
import { useParams, Link } from "react-router-dom";
import { Card, Divider, Typography, Box, Button } from "@mui/material";
import { CalendarMonth, Event } from "@mui/icons-material";
import { format } from "date-fns";
import { UserContext } from "../../../components/auth/auth-context"; 

function ConfirmPage() { 
  const { title, timeRange, time, color , businessUrl, staffUrl, userName} = useParams(); 
  const tipLink = businessUrl && staffUrl ? `/${businessUrl}/${staffUrl}/tip` : "/coins/buy";

  return (
    <Box sx={styles.container}>
      <Card sx={styles.card}>
        <Typography variant="h4" sx={styles.confirmedStyle}>
          Confirmed!
        </Typography>
        <Divider sx={styles.dividerStyle} />
        <Typography variant="body1" sx={styles.infoText}>
          You are now booked with {userName}.
        </Typography>
        <Box sx={styles.infoBox}>
          <Box sx={styles.infoItem}>
            <Box sx={styles.circleStyle(color)} />
            <Typography variant="subtitle1">{title}</Typography>
          </Box>
          <Box sx={styles.infoItem}>
            <CalendarMonth sx={styles.iconStyle} />
            <Typography variant="subtitle1">{timeRange}</Typography>
          </Box>
          <Box sx={styles.infoItem}>
            <Event sx={styles.iconStyle} />
            <Typography variant="subtitle1">
              {format(new Date(time), "EEEE, MMMM d, yyyy")}
            </Typography>
          </Box>
        </Box>
        <Divider sx={styles.dividerStyle} />
        <Typography variant="body2" sx={{ mb: 2 }}>
          A calendar invitation has been sent to your email.
        </Typography>

        {/* <Button
          component={Link}
          to={tipLink}
          variant="outlined"
          color="primary"
          fullWidth
        >
          💸 Send a Tip
        </Button> */}
      </Card>
    </Box>
  );
}

const styles = {
  container: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    mt: 4,
  },
  card: {
    width: "90%",
    maxWidth: 400,
    borderRadius: 1,
    boxShadow: "none",
    border: "1px solid #ddd",
    p: 2,
    textAlign: "center",
  },
  confirmedStyle: {
    fontWeight: "bold",
    color: "#4CAF50",
    mb: 1,
  },
  dividerStyle: {
    my: 2,
  },
  infoText: {
    color: "#333",
    mb: 2,
  },
  infoBox: {
    mb: 2,
  },
  infoItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 1,
    mb: 1,
  },
  circleStyle: (color) => ({
    width: 12,
    height: 12,
    borderRadius: "50%",
    backgroundColor: color || "#000",
  }),
  iconStyle: {
    color: "#4CAF50",
    fontSize: 20,
  },
};

export default ConfirmPage;
